// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{margin:0;padding:0}#conferwith{position:fixed;z-index:99999999999;top:0}@media screen and (max-width: 600px){#conferwith{z-index:14}}#conferwith .path1,#conferwith .path2{font-family:unset !important}#conferwith table{background-color:#fff !important}#conferwith thead th,#conferwith thead td{background-color:#000 !important;padding:5px}#conferwith a{text-decoration:none !important}#conferwith button{outline:unset !important}.boldText{font-weight:600}", ""]);
// Exports
module.exports = exports;
